import type { UseReviewedProductsSelector } from 'hooks/reviews/useReviewedProducts';
import type { Globals } from 'types/cms/Globals';
import type { JunipProduct } from 'types/reviews/JunipProduct';

import { getJunipProductsBySlugs } from './getJunipProductsBySlugs';
import { getRootProductSlug } from './getRootProductSlug';

export const reviewedProductsSelector = ({
  reviewedProducts,
  globals,
  slugsToFilter,
}: {
  reviewedProducts?: JunipProduct[];
  globals: Globals;
  slugsToFilter?: string[];
}): UseReviewedProductsSelector => {
  // If slugsToFilter exists, we get the root product slugs from all categories in case of product/site crossovers (removing any undefined values)
  const rootProductSlugs =
    globals.reviewsMainProductSlugsAllCategories && slugsToFilter
      ? slugsToFilter
          .map((slug) =>
            getRootProductSlug(
              globals.reviewsMainProductSlugsAllCategories,
              slug,
            ),
          )
          .filter((slug) => slug != null)
      : null;

  // We use the slugsToFilter root product slugs if they exist, otherwise we use the collection reviewsMainProductSlugs (site specific)
  const productSlugs = rootProductSlugs || globals.reviewsMainProductSlugs;

  // We get the Junip products by the above slugs
  const filteredJunipProducts = getJunipProductsBySlugs(
    reviewedProducts,
    productSlugs,
  );

  return filteredJunipProducts;
};
